import { render } from "./customSlider.vue?vue&type=template&id=1df104ad"
import script from "./customSlider.vue?vue&type=script&lang=js"
export * from "./customSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__